import {
  LOCALES,
  SITE_URL,
  localeHreflangLinks,
  localePath,
  type LocaleCode,
  type PageKey,
} from "./index";

/** head() payload for a new-locale page: meta, canonical, hreflang and JSON-LD. */
export function localeHead(code: LocaleCode, key: PageKey) {
  const pack = LOCALES[code];
  const page = pack.pages[key];
  const url = `${SITE_URL}${localePath(code, key)}`;

  return {
    meta: [
      { title: page.title },
      { name: "description", content: page.description },
      ...(page.keywords ? [{ name: "keywords", content: page.keywords }] : []),
      { property: "og:title", content: page.title },
      { property: "og:description", content: page.description },
      { property: "og:url", content: url },
      { property: "og:type", content: "website" },
      { property: "og:locale", content: pack.htmlLang },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: url }, ...localeHreflangLinks(key)],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "AutoRental",
          "@id": `${url}#business`,
          name: "carentals.ro — Car Rental Bucharest",
          url,
          inLanguage: pack.htmlLang,
          description: page.description,
          telephone: "+40738792499",
          priceRange: "€€",
          currenciesAccepted: "EUR, RON",
          paymentAccepted: "Cash, Debit Card, Bank Transfer",
          address: {
            "@type": "PostalAddress",
            streetAddress: "Bulevardul Regina Elisabeta 33",
            addressLocality: "Bucharest",
            addressCountry: "RO",
          },
          geo: { "@type": "GeoCoordinates", latitude: 44.4346358, longitude: 26.0955811 },
          areaServed: { "@type": "Country", name: "Romania" },
          makesOffer: {
            "@type": "Offer",
            price: "44",
            priceCurrency: "EUR",
            availability: "https://schema.org/InStock",
          },
        }),
      },
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          inLanguage: pack.htmlLang,
          mainEntity: page.faqs.map((f) => ({
            "@type": "Question",
            name: f.q,
            acceptedAnswer: { "@type": "Answer", text: f.a },
          })),
        }),
      },
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: pack.ui.breadcrumbHome,
              item: `${SITE_URL}/${code}`,
            },
            ...(key === "country"
              ? []
              : [{ "@type": "ListItem", position: 2, name: page.h1, item: url }]),
          ],
        }),
      },
    ],
  };
}
